export const getReshipmentSummaryData = state => {
  const {
    summary: { orgId, educationPeriodCd, data, addingMaterial },
  } = state.reshipment
  return { orgId, educationPeriodCd, data, addingMaterial }
}

export const getReshipmentSummaryStatusProps = state => {
  const {
    summary: { fetching, fetched, error },
  } = state.reshipment
  return { fetching, fetched, error }
}

export const getReshipmentSavingData = state => {
  const {
    summary: { orgId, educationPeriodCd },
    save: { data, name, lastUpdated, status },
  } = state.reshipment
  return { orgId, educationPeriodCd, name, lastUpdated, status, data }
}

export const getReshipmentSavingStatusProps = state => {
  const {
    save: { saving, saved, fetching, fetched, error },
  } = state.reshipment
  return { saving, saved, fetching, fetched, error }
}

export const getReshipmentSubmittingStatusProps = state => {
  const {
    submit: { submitting, submitted, error },
  } = state.reshipment
  return { submitting, submitted, error }
}

export const getNonSecureMaterials = state => {
  const {
    nonSecureMaterials: { data },
  } = state.reshipment
  return { data }
}

export const getNonSecureMaterialsStatusProps = state => {
  const {
    nonSecureMaterials: { fetching, fetched, error },
  } = state.reshipment
  return { fetching, fetched, error }
}

export const getApprovedReshipmentsData = state => {
  const {
    approvedReshipments: { data },
  } = state.reshipment
  return { data }
}

export const getApprovedReshipmentsStatusProps = state => {
  const {
    approvedReshipments: { fetching, fetched, error },
  } = state.reshipment
  return { fetching, fetched, error }
}
